// src/styles/theme.js
// 프로젝트의 모든 디자인 토큰을 중앙에서 관리하는 파일

const theme = {
  // 색상 팔레트
  colors: {
    // Primary 색상 - Main.styles.js에서 가져옴
    primary: '#667eea',
    primaryDark: '#764ba2',
    gold: '#FFD700',
    goldDark: '#FFA500',
    
    // 버튼 색상들 - Main.styles.js에서 가져옴
    success: '#2ecc71',
    successDark: '#27ae60',
    error: '#e74c3c',
    errorDark: '#c0392b',
    info: '#3498db',
    infoDark: '#2980b9',
    warning: '#ff9800',
    
    // [추가] 일반 버튼 색상
    buttonDark: '#2a2a3e',
    buttonDarkHover: '#3a3a4e',
    secondary: '#6c757d',
    secondaryHover: '#5a6268',
    
    // 구글/게스트 버튼 색상 - Login.js에서 가져옴
    google: '#4285f4',
    googleDark: '#1a73e8',
    guest: '#95a5a6',
    guestDark: '#7f8c8d',
    
    // 후원 버튼 색상 - DonationModal.js에서 가져옴
    donation: '#ff6ec4',
    donationDark: '#7873f5',
    donationSupport: '#ff69b4',
    donationSupportDark: '#ff1493',
    
    // 배경 및 표면 색상
    background: '#1a1a2e',
    backgroundDark: '#2d1b69',
    surface: 'rgba(255, 255, 255, 0.1)',
    surfaceLight: 'rgba(255, 255, 255, 0.15)',
    
    // 텍스트 색상
    text: 'white',
    textDark: '#1a1a1a',
    textMuted: 'rgba(255, 255, 255, 0.8)',
    textLight: 'rgba(255, 255, 255, 0.9)',
    
    // 테두리 색상
    border: 'rgba(255, 255, 255, 0.3)',
    borderLight: 'rgba(255, 255, 255, 0.15)',
    borderGold: 'rgba(255, 215, 0, 0.3)',
    
    // 그림자
    shadow: 'rgba(0, 0, 0, 0.3)',
    shadowDark: 'rgba(0, 0, 0, 0.5)',
    shadowLight: 'rgba(0, 0, 0, 0.1)',
  },
  
  // 레이아웃 수치
  layout: {
    maxWidth: '450px', // App.css에서 가져옴
    bottomBarHeight: '45px', // Main.styles.js에서 가져옴
    gameHeaderHeight: '80px', // Game.css에서 가져옴
    gameControlHeight: '90px', // Game.css에서 가져옴
    
    // 패딩 값들
    padding: {
      small: '0.5rem',
      medium: '1rem',
      large: '1.5rem',
      xlarge: '2rem',
    },
    
    // 여백 값들
    margin: {
      small: '0.5rem',
      medium: '1rem',
      large: '1.5rem',
      xlarge: '2rem',
    },
  },
  
  // 테두리 반경
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    xlarge: '15px',
    xxlarge: '20px',
    round: '25px',
    pill: '30px',
  },
  
  // 폰트 크기
  fontSize: {
    // 기본 텍스트
    tiny: '0.65rem',
    small: '0.75rem',
    medium: '0.85rem',
    normal: '1rem',
    large: '1.1rem',
    xlarge: '1.5rem',
    xxlarge: '2rem',
    xxxlarge: '2.5rem',
    
    // 버튼 텍스트 - [수정] 작게 조정
    button: '0.9rem',        // 1rem → 0.9rem
    buttonSmall: '0.8rem',   // 0.85rem → 0.8rem
    
    // 제목
    h1: '2rem',
    h2: '1.5rem',
    h3: '1.2rem',
  },
  
  // z-index 레이어
  zIndex: {
    base: 1,
    dropdown: 100,
    sticky: 200,
    fixed: 300,
    modalBackdrop: 1000,
    modal: 2000,
    popover: 3000,
    tooltip: 4000,
  },
  
  // 애니메이션 지속 시간
  transitions: {
    fast: '0.2s',
    normal: '0.3s',
    slow: '0.5s',
  },
  
  // 미디어 쿼리 브레이크포인트
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
  
  // 공통 그림자 효과
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 15px rgba(0, 0, 0, 0.3)',
    large: '0 8px 32px rgba(0, 0, 0, 0.3)',
    xlarge: '0 15px 50px rgba(0, 0, 0, 0.5)',
    
    // 색상별 그림자
    gold: '0 4px 15px rgba(255, 215, 0, 0.3)',
    goldLarge: '0 6px 20px rgba(255, 215, 0, 0.4)',
    success: '0 4px 15px rgba(46, 204, 113, 0.3)',
    error: '0 4px 15px rgba(231, 76, 60, 0.3)',
    info: '0 4px 15px rgba(52, 152, 219, 0.3)',
  },
  
  // 공통 애니메이션 키프레임 (문자열로 정의)
  animations: {
    fadeIn: `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
    `,
    popIn: `
      @keyframes popIn {
        from { 
          opacity: 0; 
          transform: scale(0.8); 
        }
        to { 
          opacity: 1; 
          transform: scale(1); 
        }
      }
    `,
    pulse: `
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
    `,
    shine: `
      @keyframes shine {
        0% {
          transform: rotate(45deg) translateX(-100%);
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
        100% {
          transform: rotate(45deg) translateX(100%);
          opacity: 0;
        }
      }
    `,
    float: `
      @keyframes float {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        33% { transform: translate(30px, -30px) rotate(120deg); }
        66% { transform: translate(-20px, 20px) rotate(240deg); }
      }
    `,
    bounce: `
      @keyframes bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
    `,
    sparkle: `
      @keyframes sparkle {
        0%, 100% { 
          opacity: 0;
          transform: scale(0) rotate(0deg);
        }
        50% { 
          opacity: 1;
          transform: scale(1) rotate(180deg);
        }
      }
    `,
    spin: `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `,
    shimmer: `
      @keyframes shimmer {
        0% { opacity: 0.8; }
        50% { opacity: 1; }
        100% { opacity: 0.8; }
      }
    `,
    gradient: `
      @keyframes gradient {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `,
  },
};

export default theme;